<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  class={$$props.class}
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M3 3H21V21H3V3ZM16.911 9.75001L15.4968 8.3358L10.9968 12.8358L8.99676 10.8358L7.58255 12.25L10.9968 15.6642L16.911 9.75001Z"
    fill="currentColor"
  />
</svg>
